"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartDate = require("./ChartDate.styled");
var _constants = require("../constants");
function ChartDate(_ref) {
  let {
    data,
    theme
  } = _ref;
  const allYears = Array.from(new Set(data.map(d => d.points.map(p => p[_constants.COL_YEAR]).flat()).flat())).filter(year => !isNaN(Number(year))).sort();
  const range = [allYears.at(0), allYears.at(-1)];
  if (range[0] === range[1]) {
    range.pop();
  }
  return /*#__PURE__*/_react.default.createElement(_ChartDate.ContainerDate, {
    color: theme.colors.main
  }, "(", range.join("-"), ")");
}
var _default = ChartDate;
exports.default = _default;